import classNames from 'clsx';
import React from 'react';
import { Field } from 'react-final-form';

import styles from '@swf/components/RegulatoryCheckboxes/RegulatoryCheckboxes.scss';
import useValidator from '@swf/core/hooks/useValidator';
import { required } from '@swf/core/utils/validators';

import Checkbox from '../../../../../Checkbox/Checkbox';

import { TXTCLI_I_understand_that_this_informa_ELL } from './Confirmation.messages.json';

const Confirmation: React.FunctionComponent = () => {
  const [validator] = useValidator(required());
  return (
    <Field name="confirmation" type="checkbox" validate={validator}>
      {({ input: { onChange, checked }, meta }) => (
        <div
          className={classNames(styles.wrapper, {
            [styles.eligible]: false
          })}
        >
          <Checkbox
            meta={meta}
            name="confirmation"
            onChange={onChange}
            label={{ ...TXTCLI_I_understand_that_this_informa_ELL }}
          />
        </div>
      )}
    </Field>
  );
};

export default Confirmation;
